export default {
  INPUT_TEXT: 'INPUT_TEXT',
  INPUT_SECURE_TEXT: 'INPUT_SECURE_TEXT',
  INPUT_TEXT_AREA: 'INPUT_TEXT_AREA',
  MASKED_INPUT_TEXT: 'MASKED_INPUT_TEXT',
  MASKED_INPUT_TEXT_CURRENCY: 'MASKED_INPUT_TEXT_CURRENCY',
  PICKER: 'PICKER',
  DATE_PICKER: 'DATE_PICKER',
};
